function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb351"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb351"] = parcelRequire;
}
parcelRequire.register("NGS1k", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0955d4ddbfd84957$export$6503ec6e8aabbaf; }, function (v) { return $0955d4ddbfd84957$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0955d4ddbfd84957$export$f7ad0328861e2f03; }, function (v) { return $0955d4ddbfd84957$export$f7ad0328861e2f03 = v; });
var $0955d4ddbfd84957$export$6503ec6e8aabbaf;
var $0955d4ddbfd84957$export$f7ad0328861e2f03;
"use strict";
var $0955d4ddbfd84957$var$mapping = {};
function $0955d4ddbfd84957$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$0955d4ddbfd84957$var$mapping[keys[i]] = pairs[keys[i]];
}
function $0955d4ddbfd84957$var$resolve(id) {
    var resolved = $0955d4ddbfd84957$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$0955d4ddbfd84957$export$6503ec6e8aabbaf = $0955d4ddbfd84957$var$register;
$0955d4ddbfd84957$export$f7ad0328861e2f03 = $0955d4ddbfd84957$var$resolve;

});

var $5915cfe9dc0ccfb3$exports = {};

(parcelRequire("NGS1k")).register(JSON.parse('{"8dupi":"index.52cb9a39.js","kwbZD":"frame.5b787238.svg","kfgqv":"SoundFX3-AnyButton.6d3cc61a.mp3","2xGvs":"trophy-1st.6a93664c.svg","dEtow":"trophy-2nd.369eda49.svg","e28Bh":"trophy-3rd.96f8ea6f.svg","6SYpc":"trophy.5ff339db.svg","7lP95":"seemode.c4e19dcb.svg","byNfd":"background.dffda619.svg","9XjWp":"panel.502c2c04.svg","4vkAF":"SoundFX1-TRbutton.c4e3b494.mp3","4kVzG":"clock.a4ec9920.svg","5hTBV":"SoundFX2-Win.1d21e86d.mp3","hy1u4":"UltrasoundImage.de505c29.svg","8NGDQ":"BGsoundscape1.af483d6d.mp3","2SjHP":"BGsoundscape2.c6a7cbd9.mp3"}'));


//# sourceMappingURL=index.7a46957c.js.map
